import React from "react";

const RecycleBinWindow = ({ navigate }) => (
  <div className="flex h-full flex-col items-center justify-center gap-4 bg-white p-8 text-center font-ui text-win-text">
    <span className="text-6xl" aria-hidden="true">🗑️</span>
    <p className="text-sm font-bold">This folder is empty.</p>
    <p className="max-w-xs text-xs leading-5 text-[#404040]">
      No deleted files here — but my job search inbox has room. If you're hiring, don't send this to the bin.
    </p>
    <button type="button" onClick={() => navigate("contact")} className="win-btn win-focus-dotted px-3 py-1.5 text-xs font-bold">
      ✉ Contact me instead
    </button>
  </div>
);

export default RecycleBinWindow;
